import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  isAuthenticated: false,
  type: null,
  user: null,
  team: null,
  teamUser: null,
  role: null,
  token: null,
  onboardingStage: null,
  enabledAts: [],
  atsEnabled: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    loginAction: (state, action) => {
      const payload = action.payload
      const type = payload.data.type
      const team = payload.data.team
      const teamUser = payload.data.teamUser

      state.isAuthenticated = true
      state.type = type
      state.user = payload.data.user
      state.team = team
      state.teamUser = teamUser
      state.role = payload.data.role
      state.token = payload.token
      state.onboardingStage = payload.data.onboardingStage

      state.atsEnabled = team?.allowedIntegrations?.length > 0
      state.enabledAts = team?.allowedIntegrations || []
    },
    logoutAction: (state, _) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        state[key] = INITIAL_STATE[key]
      })
    },
    changeOnboardingStageAction: (state, action) => {
      state.onboardingStage = action.payload
    },
    changeDetailsAction: (state, action) => {
      state.teamUser.position = action.payload.position
      state.user.name = action.payload.name
      state.user.email = action.payload.email
      state.user.phoneNumber = action.payload.phoneNumber
    },
    changeTeamDetailsAction: (state, action) => {
      state.team.type = action.payload.type.value
      state.team.name = action.payload.name
      state.team.registrationNumber = action.payload.registrationNumber
      state.team.billingEmail = action.payload.billingEmail
      state.team.billingCountryCode = action.payload.billingCountryCode?.value || null
      state.team.billingAddress = action.payload.billingAddress
    },
    changeTeamLanguageAction: (state, action) => {
      state.team.language = action.payload
    }
  },
})

export const {
  loginAction,
  logoutAction,
  changeOnboardingStageAction,
  changeDetailsAction,
  changeTeamDetailsAction,
  changeTeamLanguageAction,
} = authSlice.actions

export const selectRole = (state) => state.auth.role;
export const selectTeam = (state) => state.auth.team;
export const selectTeamUser = (state) => state.auth.teamUser;
export const selectUser = (state) => state.auth.user;

export default authSlice.reducer
